<div
  class="app-grid-fluid md:mt-3 md:mb-3 py-2"
  appPullToRefresh
  [pullToRefreshContext]="activeCategory"
  #ptr="appPullToRefresh"
  (refresh)="onPullToRefresh($event)"
>
  <div class="grid grid-nogutter justify-content-center">
    <div class="col-12 sm:col-10 xl:col-6" [style]="{maxWidth: '980px'}">
      <p-tabView
        #rankingTabView
        class="ranking-tabview-host"
        [scrollable]="true"
        [activeIndex]="activeTabIndex"
        (onChange)="onTabChange($event)"
        styleClass="ranking-tabs screen-sticky-tabview"
      >
        <p-tabPanel *ngFor="let category of categories; let i = index"
                    [header]="category.label | translate"
                    [selected]="i === activeTabIndex">
        </p-tabPanel>
      </p-tabView>

      <swiper #rankingSwiper class="ranking-swiper" [config]="swiperConfig" (activeIndexChange)="onSwipeIndexChange($event)">
        <ng-template swiperSlide *ngFor="let category of categories; let categoryIndex = index">
          <section
            class="ranking-tab-slide"
            role="region"
            [attr.aria-label]="category.label | translate"
            [attr.aria-hidden]="categoryIndex !== activeTabIndex"
            [attr.inert]="categoryIndex === activeTabIndex ? null : ''"
            (dragstart)="$event.preventDefault()"
          >
            <ng-container *ngIf="shouldRenderCategory(categoryIndex)">
              <ng-container *ngIf="tabStates[category.key] as state">
                <div *ngIf="state.error" class="px-3 py-3 muted-text">
                  {{ 'common.something_went_wrong' | translate }}
                </div>

                <ng-container *ngIf="isProjectTab(category.key)">
                  <p-dataView *ngIf="state.projects.length" [value]="state.projects" [paginator]="false" [rows]="pageSize">
                    <ng-template let-projects pTemplate="list">
                      <div *ngFor="let project of projects; index as i" class="col-12 p-0 m-0 mb-2">
                        <p-card *ngIf="project.isPlaceholder">
                          <div class="grid">
                            <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                              {{ getProjectRank(i, category.key) }}.
                            </div>
                            <div class="col">
                              <div class="col-12 p-0 pt-2 pb-2 vehicle-name white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                <p-skeleton width="70%" height="1.2rem"></p-skeleton>
                              </div>
                              <div class="col-12">
                                <div class="grid">
                                  <div class="col-5 p-0 theme-box">
                                    <p-skeleton styleClass="avatar p-avatar-xl"></p-skeleton>
                                  </div>
                                  <div class="col pt-0">
                                    <div class="grid grid-nogutter">
                                      <div class="col-12 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
                                        <p-skeleton width="60%" height="1.1rem"></p-skeleton>
                                      </div>
                                      <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                        <p-skeleton width="50%" height="1.1rem"></p-skeleton>
                                      </div>
                                      <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                        <p-skeleton width="80%" height="1.1rem"></p-skeleton>
                                      </div>
                                      <div class="col-12 p-0 mb-2" style="font-size: 1.1em">
                                        <p-skeleton width="35%" height="1.1rem"></p-skeleton>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-fixed flex flex-column justify-content-center" aria-hidden="true">
                              <p-skeleton *ngFor="let action of [1, 2, 3, 4]" width="2.5rem" height="2.5rem" styleClass="m-1" shape="circle"></p-skeleton>
                            </div>
                          </div>
                        </p-card>

                        <p-card *ngIf="!project.isPlaceholder">
                          <div class="grid">
                            <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                              {{ getProjectRank(i, category.key) }}.
                            </div>
                            <div class="col">
                              <div class="col-12 p-0 pt-3 pb-2 vehicle-name white-space-nowrap overflow-hidden text-overflow-ellipsis">
                                <a class="no-underline">{{ project.vehicle.fullVehicleIdentity }}</a>
                              </div>
                              <div class="col-12">
                                <div class="grid">
                                  <div class="col-5 p-0 theme-box">
                                    <p-avatar
                                      size="xlarge"
                                      styleClass="avatar"
                                      image="{{project.theme | mediaObject: {defaultImageType: getDefaultImageType(project)} }}"
                                    >
                                      <div class="justify-content-center align-items-center ranking-number md:hidden flex">
                                        <span>{{ getProjectRank(i, category.key) }}.</span>
                                      </div>
                                    </p-avatar>
                                  </div>
                                  <div class="col pt-0">
                                    <div class="grid grid-nogutter">
                                      <div class="col-12 white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
                                        <i class="pi pi-user mr-2"></i>
                                        <a *ngIf="project.user?.slug; else rankingProjectOwnerName" [routerLink]="['/', project.user.slug, 'profile']">{{ project.user.username }}</a>
                                        <ng-template #rankingProjectOwnerName>
                                          <span>{{ project.user.username }}</span>
                                        </ng-template>
                                      </div>

                                      <ng-container *ngIf="category.key !== 'strongest'; else strongestMetrics">
                                        <div class="col-12 p-0 flex mb-2 gap-2" style="font-size: 1.1em">
                                          <div class="rating inline-flex gap-1">
                                            <ng-container *ngFor="let star of [1, 2, 3, 4, 5, 6]">
                                              <i [ngClass]="getIconForStar(star, project.averageRating?.toPrecision ? project.averageRating.toPrecision(3) : project.averageRating)"></i>
                                            </ng-container>
                                          </div>
                                        </div>
                                        <div *ngIf="!project.user.settings?.privacy?.hideRating" class="col-12 p-0 mb-2" style="font-size: 1.1em;">
                                          {{ 'common.ratings_average_short'|translate }}
                                          <span class="count">{{ project.averageRating?.toPrecision ? project.averageRating.toPrecision(3) : project.averageRating }}</span>
                                          {{ 'common.from'|translate }}
                                          <span class="count">{{ project.ratingCount }}</span>
                                          {{ 'common.ratings'|translate | translateSelector: project.ratingCount }}
                                        </div>
                                        <div class="col-12 p-0 mb-2 inline-flex align-items-center" style="font-size: 1.1em">
                                          {{ 'common.your_rate'|translate }}:
                                          <span *ngIf="project.currentUserRating > 0" class="ranking-rate px-1">{{ project.currentUserRating }}</span>
                                          <ng-container *ngIf="project.currentUserRating === 0">~</ng-container>
                                        </div>
                                      </ng-container>

                                      <ng-template #strongestMetrics>
                                        <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                          {{ 'feature.user.project.parameters.power' | translate }}:
                                          <span class="count">{{ getStrongestMetrics(project).power ?? '—' }}</span>
                                          <span *ngIf="getStrongestMetrics(project).power !== undefined">{{ 'common.bhp' | translate }}</span>
                                        </div>
                                        <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                          {{ 'feature.user.project.parameters.max_speed' | translate }}:
                                          <span class="count">{{ getStrongestMetrics(project).maxSpeed ?? '—' }}</span>
                                          <span *ngIf="getStrongestMetrics(project).maxSpeed !== undefined">{{ 'common.km_h' | translate }}</span>
                                        </div>
                                        <div class="col-12 p-0 mb-2 metric-line" style="font-size: 1.05em">
                                          {{ 'feature.user.project.parameters.acceleration' | translate }}:
                                          <span class="count">{{ getStrongestMetrics(project).acceleration ?? '—' }}</span>
                                          <span *ngIf="getStrongestMetrics(project).acceleration !== undefined">{{ 'common.s' | translate }}</span>
                                        </div>
                                      </ng-template>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-fixed pl-0 flex flex-column justify-content-center">
                              <button pButton pRipple icon="navigation-vehicles-icon" class="p-button-text p-button-rounded p-button-sm m-1 p-0 ranking-project-link" type="button" (click)="openProject(project, $event)" [attr.aria-label]="'shared.listing_tile.button.go_to_project' | translate" [pTooltip]="'shared.listing_tile.button.go_to_project' | translate"></button>
                              <button pButton pRipple icon="pi pi-warehouse text-2xl" class="p-button-text p-button-plain p-button-rounded p-button-sm m-1" type="button" (click)="openGarage(project, $event)" [attr.aria-label]="'common.garage' | translate" [pTooltip]="'common.garage' | translate"></button>
                              <button pButton pRipple icon="pi pi-user text-2xl" class="p-button-text p-button-plain p-button-rounded p-button-sm m-1" type="button" (click)="openProfileForProject(project, $event)" [disabled]="!project.user?.slug" [attr.aria-label]="'common.profile' | translate" [pTooltip]="'common.profile' | translate"></button>
                              <button pButton pRipple icon="pi pi-qrcode text-2xl" class="p-button-text p-button-plain p-button-rounded p-button-sm m-1" type="button" (click)="openQrDialog(project, $event)" [attr.aria-label]="'common.share' | translate" [pTooltip]="'common.share' | translate"></button>
                            </div>
                          </div>
                        </p-card>
                      </div>
                    </ng-template>
                  </p-dataView>

                  <div *ngIf="state.loaded && !state.loading && !state.projects.length && !state.error" class="width-100 flex justify-content-center mb-3 pt-1 muted-text text-center">
                    {{ 'common.no_results' | translate }}
                  </div>
                </ng-container>

                <ng-container *ngIf="category.key === 'users'">
                  <div *ngFor="let record of state.users; index as i" class="col-12 p-0 m-0 mb-2">
                    <p-card>
                      <div class="grid align-items-center">
                        <div class="col-1 justify-content-center align-items-center ranking-number hidden md:flex">
                          {{ getProjectRank(i, category.key) }}.
                        </div>
                        <div class="col-auto pr-0">
                          <div class="ranking-user-avatar">
                            <p-avatar
                              *ngIf="record.user.avatar; else rankingUserAvatarFallback"
                              [image]="record.user.avatar | mediaObject: {defaultImageType: 'avatar', formatType: 'thumb_sm'}"
                              size="xlarge"
                              styleClass="avatar"
                            >
                              <div class="justify-content-center align-items-center ranking-number ranking-number-user md:hidden flex">
                                <span>{{ getProjectRank(i, category.key) }}.</span>
                              </div>
                            </p-avatar>
                            <ng-template #rankingUserAvatarFallback>
                              <p-avatar
                                [label]="record.user.username?.slice(0, 1)"
                                size="xlarge"
                                styleClass="avatar"
                              >
                                <div class="justify-content-center align-items-center ranking-number ranking-number-user md:hidden flex">
                                  <span>{{ getProjectRank(i, category.key) }}.</span>
                                </div>
                              </p-avatar>
                            </ng-template>
                          </div>
                        </div>
                        <div class="col">
                          <div class="font-medium mb-2">
                            <a *ngIf="record.user?.slug; else rankingUserName" [routerLink]="['/', record.user.slug, 'profile']">{{ record.user.username }}</a>
                            <ng-template #rankingUserName>
                              <span>{{ record.user.username }}</span>
                            </ng-template>
                          </div>
                          <div class="mb-1">
                            {{ 'features.ranking.user.average_rating' | translate }}:
                            <span class="count">{{ record.averageRating }}</span>
                          </div>
                          <div class="mb-1">
                            {{ 'features.ranking.user.ratings_count' | translate }}:
                            <span class="count">{{ record.ratingCount }}</span>
                          </div>
                          <div>
                            {{ 'features.ranking.user.ranked_vehicle_count' | translate }}:
                            <span class="count">{{ record.rankedVehicleCount }}</span>
                          </div>
                        </div>
                        <div class="col-fixed">
                          <button pButton pRipple icon="pi pi-user text-2xl" class="p-button-text p-button-rounded p-button-sm m-1" type="button" (click)="openProfile(record, $event)" [disabled]="!record.user?.slug" [attr.aria-label]="'common.profile' | translate" [pTooltip]="'common.profile' | translate"></button>
                        </div>
                      </div>
                    </p-card>
                  </div>

                  <div *ngIf="(state.loading || !state.loaded) && !state.error && !state.users.length" class="px-2">
                    <p-card *ngFor="let item of [1,2,3,4]" styleClass="mb-2">
                      <div class="grid align-items-center">
                        <div class="col-auto">
                          <div class="ranking-user-avatar">
                            <p-skeleton width="5rem" height="5rem" styleClass="ranking-user-avatar-skeleton"></p-skeleton>
                          </div>
                        </div>
                        <div class="col">
                          <p-skeleton width="40%" height="1.1rem" styleClass="mb-2"></p-skeleton>
                          <p-skeleton width="55%" height="1rem" styleClass="mb-2"></p-skeleton>
                          <p-skeleton width="50%" height="1rem" styleClass="mb-2"></p-skeleton>
                        </div>
                        <div class="col-fixed" aria-hidden="true">
                          <p-skeleton width="2.5rem" height="2.5rem" styleClass="m-1" shape="circle"></p-skeleton>
                        </div>
                      </div>
                    </p-card>
                  </div>

                  <div *ngIf="state.loaded && !state.loading && !state.users.length && !state.error" class="width-100 flex justify-content-center mb-3 pt-1 muted-text text-center">
                    {{ 'common.no_results' | translate }}
                  </div>
                </ng-container>

                <p-paginator
                  *ngIf="state.total > state.limit"
                  [rows]="state.limit"
                  [totalRecords]="state.total"
                  [first]="(state.page - 1) * state.limit"
                  [rowsPerPageOptions]="[pageSize]"
                  (onPageChange)="onPageChange($event, category.key)"
                  styleClass="ranking-paginator"
                ></p-paginator>
              </ng-container>
            </ng-container>
          </section>
        </ng-template>
      </swiper>
    </div>
  </div>
</div>
<app-qr-dialog [(visible)]="qrDialogVisible" [data]="qrDialogData"></app-qr-dialog>
